import type { RiskRating } from '@auctionradar/shared';

const RISK_LABEL: Record<RiskRating, string> = {
  green: '🟢 Καθαρό',
  yellow: '🟡 Μέτριο',
  red: '🔴 Υψηλό',
};

export function RiskBadge({ risk }: { risk: RiskRating | null }) {
  if (risk == null) {
    return (
      <span className="text-xs text-slate-400">—</span>
    );
  }
  return (
    <span className="text-xs font-medium text-slate-700">{RISK_LABEL[risk]}</span>
  );
}
